/**
 * MeridianLockup: canonical brand mark + wordmark + tagline.
 *
 * Used by DashboardShell (sidebar header), Login, NotFound, and any
 * future signed-out surface. Sizes via the `size` prop so the same
 * markup works in a 240px sidebar and a centered card.
 */

export interface MeridianLockupProps {
  size?: "sm" | "md" | "lg";
  align?: "row" | "stack";
}

const MARK = {
  sm: 28,
  md: 40,
  lg: 56,
} as const;

const WORDMARK_SIZE = {
  sm: 13,
  md: 16,
  lg: 20,
} as const;

const TAGLINE_SIZE = {
  sm: 9,
  md: 11,
  lg: 12,
} as const;

export default function MeridianLockup({ size = "md", align = "row" }: MeridianLockupProps) {
  const markSize = MARK[size];
  const wordmarkSize = WORDMARK_SIZE[size];
  const taglineSize = TAGLINE_SIZE[size];

  const layout =
    align === "stack"
      ? {
          display: "grid",
          justifyItems: "center",
          gap: 12,
        }
      : {
          display: "flex",
          alignItems: "center",
          gap: 10,
        };

  return (
    <div style={layout}>
      <img
        src="/brand/meridian-mark.png"
        srcSet="/brand/meridian-mark.png 1x, /brand/meridian-mark-2x.png 2x"
        alt="Meridian"
        width={markSize}
        height={markSize}
        style={{ flexShrink: 0, display: "block" }}
      />
      <div
        style={{
          lineHeight: 1.05,
          fontWeight: 800,
          letterSpacing: 0.3,
          textAlign: align === "stack" ? "center" : "left",
        }}
      >
        <div style={{ fontSize: wordmarkSize, color: "var(--text)" }}>MERIDIAN ANALYTICS</div>
        <div
          style={{
            fontSize: taglineSize,
            color: "var(--text-2)",
            fontWeight: 500,
            letterSpacing: 0.8,
          }}
        >
          Operations Intelligence
        </div>
      </div>
    </div>
  );
}
